import React from 'react';
import { useAuditLogByWorkOrder } from '../../../entities/audit-log';
import { FormSection } from '../../../shared/ui/controls/FormSection/FormSection';
import { AuditLogItem } from './AuditLogItem';

interface AuditLogFeedProps {
  workOrderId: string;
}

export const AuditLogFeed: React.FC<AuditLogFeedProps> = ({ workOrderId }) => {
  const { data, isLoading } = useAuditLogByWorkOrder(workOrderId);

  return (
    <>
    
    <FormSection title="Verlauf">
      {isLoading && (
        <p className="text-sm text-gray-400">Lade...</p>
      )}
      {!isLoading && (!data || data.length === 0) && (
        <p className="text-sm text-gray-400">Keine Einträge vorhanden.</p>
      )}
      
      {data && data.length > 0 && (
        <div className="flex flex-col">
          {data.map((entry) => (
            <AuditLogItem key={entry.id} entry={entry} />
          ))}
        </div>
      )}
    </FormSection></>
  );
};
